import { useQuery } from "@tanstack/react-query";
import { getAllHotelExtras } from "../../api/apiHotelExtras";

const QUERY_KEY = ["hotelExtras"];

const useGetHotelExtras = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllHotelExtras(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelExtras: data?.data || data?.hotelExtras || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetHotelExtras;
